import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../Services/servicioURL';

const Login: React.FC = () => {
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [serverStatus, setServerStatus] = useState<'checking' | 'connected' | 'error'>('checking');
    const navigate = useNavigate();

    useEffect(() => {
        const checkServerConnection = async () => {
            try {
                const response = await fetch(`${BASE_URL}/usuario/login`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ usuario: 'test', contraseña: 'test' }),
                });
                setServerStatus('connected');
            } catch (err) {
                setServerStatus('error');
            }
        };

        const timer = setTimeout(checkServerConnection, 2000);
        return () => clearTimeout(timer);
    }, []);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!username || !password) {
            setError("Usuario y contraseña son obligatorios");
            return;
        }
        
        setIsLoading(true);
        
        // Intentar login de usuario normal primero
        try {
            const userResponse = await fetch(`${BASE_URL}/usuario/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ usuario: username, contraseña: password }),
            });

            if (userResponse.ok) {
                const userData = await userResponse.json();
                localStorage.setItem('authToken', 'logueado');
                localStorage.setItem('idUsuario', userData.usuario.id.toString());
                localStorage.setItem('nombreUsuario', userData.usuario.nombre);
                setTimeout(() => navigate('/inicio'), 1000);
                return;
            }
        } catch (err) {
            console.error('Error en login usuario:', err);
        }

        // Si falla, intentar login de empleado
        try {
            const empResponse = await fetch(`${BASE_URL}/empleado/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ cveemp: username, password: password }),
            });

            if (empResponse.ok) {
                const empData = await empResponse.json();
                localStorage.setItem('authToken2', 'logueado');
                localStorage.setItem('cveEmpleado', empData.empleado.cveemp);
                localStorage.setItem('nombreEmpleado', empData.empleado.nomemp);
                setTimeout(() => navigate('/empinicio'), 1000);
                return;
            }
        } catch (err) {
            console.error('Error en login empleado:', err);
        }

        setError('Credenciales incorrectas');
        setIsLoading(false);
    };

    const handleInputChange = () => setError('');

    const retryConnection = () => {
        setServerStatus('checking');
        setTimeout(async () => {
            try {
                await fetch(`${BASE_URL}/usuario/login`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ usuario: 'test', contraseña: 'test' }),
                });
                setTimeout(() => setServerStatus('connected'), 1500);
            } catch (err) {
                setServerStatus('error');
            }
        }, 500);
    };

    // Crear el keyframe de animación dinámicamente
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            @keyframes spinAnimation {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    if (serverStatus !== 'connected') {
        return (
            <div style={{
                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
            }}>
                {serverStatus === 'checking' ? (
                    <div style={{ color: '#fff', textAlign: 'center' }}>
                        <div style={{
                            width: '60px',
                            height: '60px',
                            border: '4px solid rgba(255, 255, 255, 0.2)',
                            borderTop: '4px solid #64b5f6',
                            borderRadius: '50%',
                            margin: '0 auto',
                            animation: 'spinAnimation 1s linear infinite'
                        }}></div>
                        <p style={{ fontSize: '16px', fontWeight: '500', marginTop: '20px' }}>
                            Conectando con el servidor...
                        </p>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', color: '#fff' }}>
                        <div style={{ 
                            fontSize: '48px', 
                            color: '#ff6b6b', 
                            marginBottom: '20px' 
                        }}>
                            ⚠️
                        </div>
                        <p style={{ color: '#ff6b6b', marginBottom: '20px', fontSize: '16px' }}>
                            Error al conectarse con el servidor
                        </p>
                        <Button 
                            label="Reintentar" 
                            icon="pi pi-refresh"
                            onClick={retryConnection}
                            style={{ 
                                backgroundColor: '#64b5f6', 
                                border: '1px solid #64b5f6',
                                color: '#fff',
                                borderRadius: '8px',
                                padding: '12px 24px'
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="login-page" style={{ 
            minHeight: '100vh', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)'
        }}>
            <div className="card p-4" style={{ 
                width: '400px', 
                borderRadius: '16px', 
                backgroundColor: 'rgba(30, 30, 46, 0.95)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <img src="/dist/img/BBT_BLANCO.png" alt="BBT Logo" style={{ width: '120px' }} />
                </div>

                <h3 className="text-center mb-4" style={{ color: '#ffffff', fontWeight: '600' }}>
                    Iniciar Sesión
                </h3>

                {error && (
                    <div className="alert alert-danger text-center mb-3" style={{ 
                        backgroundColor: 'rgba(244, 67, 54, 0.15)', 
                        border: '1px solid rgba(244, 67, 54, 0.3)', 
                        borderRadius: '8px', 
                        padding: '12px',
                        color: '#ff6b6b'
                    }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleLogin}>
                    <div className="form-group mb-3">
                        <label style={{ color: '#e0e0e0', marginBottom: '8px', display: 'block' }}>
                            Usuario / Clave Empleado
                        </label>
                        <InputText 
                            className="form-control w-100" 
                            placeholder="Usuario o clave de empleado" 
                            value={username}
                            onChange={(e) => { setUsername(e.target.value); handleInputChange(); }}
                            style={{ 
                                height: '45px', 
                                borderRadius: '8px',
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                color: '#ffffff'
                            }}
                            disabled={isLoading}
                        />
                    </div>

                    <div className="form-group mb-4">
                        <label style={{ color: '#e0e0e0', marginBottom: '8px', display: 'block' }}>
                            Contraseña
                        </label>
                        <InputText 
                            type="password" 
                            className="form-control w-100" 
                            placeholder="Contraseña" 
                            value={password}
                            onChange={(e) => { setPassword(e.target.value); handleInputChange(); }}
                            style={{ 
                                height: '45px', 
                                borderRadius: '8px',
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                color: '#ffffff'
                            }}
                            disabled={isLoading}
                        />
                    </div>

                    <Button 
                        label={isLoading ? "Ingresando..." : "Ingresar"}
                        icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-sign-in"}
                        className="w-100" 
                        style={{ 
                            height: '45px', 
                            backgroundColor: '#64b5f6', 
                            border: '1px solid #64b5f6',
                            borderRadius: '8px',
                            fontWeight: '500'
                        }}
                        type="submit"
                        disabled={isLoading}
                    />
                </form>

                <Button 
                    label="Continuar como invitado" 
                    icon="pi pi-user" 
                    className="mt-3 w-100" 
                    style={{ 
                        height: '45px', 
                        backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        color: '#e0e0e0',
                        borderRadius: '8px'
                    }}
                    onClick={() => navigate('/invinicio')}
                    disabled={isLoading}
                />
            </div>

            <style>{`
                /* Estilos para inputs */
                .p-inputtext::placeholder {
                    color: rgba(255, 255, 255, 0.5) !important;
                }
                
                .p-inputtext:focus {
                    border-color: #64b5f6 !important;
                    box-shadow: 0 0 0 0.2rem rgba(100, 181, 246, 0.25) !important;
                }
                
                /* Hover effects */
                .p-button:hover {
                    transform: translateY(-1px);
                    transition: all 0.3s ease;
                }
                
                /* Responsive */
                @media (max-width: 480px) {
                    .card {
                        width: 90% !important;
                        margin: 20px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Login;